import React, { useEffect, useState } from "react";
import {
  Card, CardBody, CardHeader,
  Container, Badge, Button, Table,
} from "reactstrap";
import { bookingsRepo } from "data/repositories/bookingsRepo";
import EmptyState from "components/EmptyState";

const STATUS_COLOR = { pending: "warning", confirmed: "success", cancelled: "danger" };
const STATUS_LABEL = { pending: "Bekliyor", confirmed: "Onaylandı", cancelled: "İptal" };

export default function PartnerBookings() {
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    setBookings(bookingsRepo.list());
  }, []);

  const handleStatus = (id, status) => {
    bookingsRepo.updateStatus(id, status);
    setBookings(bookingsRepo.list());
  };

  return (
    <>
      <div className="header bg-gradient-warning pb-6 pt-5 pt-md-7">
        <Container fluid>
          <h2 className="text-white mb-0">Partner — Rezervasyonlar</h2>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Card className="shadow">
          <CardHeader><h3 className="mb-0">Gelen Rezervasyonlar</h3></CardHeader>
          <CardBody>
            {bookings.length === 0 ? (
              <EmptyState title="Henüz rezervasyon yok" />
            ) : (
              <Table className="align-items-center" responsive>
                <thead className="thead-light">
                  <tr>
                    <th>Müşteri</th>
                    <th>İşletme</th>
                    <th>Başlangıç</th>
                    <th>Gece</th>
                    <th>Durum</th>
                    <th>İşlem</th>
                  </tr>
                </thead>
                <tbody>
                  {bookings.map((b) => (
                    <tr key={b.id}>
                      <td>{b.customerName || "-"}</td>
                      <td>{b.businessId}</td>
                      <td>{b.startDate || "-"}</td>
                      <td>{b.nights || "-"}</td>
                      <td>
                        <Badge color={STATUS_COLOR[b.status] || "secondary"}>
                          {STATUS_LABEL[b.status] || b.status}
                        </Badge>
                      </td>
                      <td>
                        {b.status === "pending" && (
                          <>
                            <Button color="success" size="sm" className="mr-1" onClick={() => handleStatus(b.id, "confirmed")}>
                              Onayla
                            </Button>
                            <Button color="danger" size="sm" onClick={() => handleStatus(b.id, "cancelled")}>
                              Reddet
                            </Button>
                          </>
                        )}
                        {b.status === "confirmed" && (
                          <Button color="danger" size="sm" onClick={() => handleStatus(b.id, "cancelled")}>
                            İptal Et
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </CardBody>
        </Card>
      </Container>
    </>
  );
}
